import Config from "../configs/configs"
let credentials = localStorage.getItem('auth');
import b64 from "./b64"

const handlerAuth = res => {
    if (res.SERVER_INFO?.AUTH) {
        let auth = JSON.parse(credentials);
        auth.jwt = res.SERVER_INFO.AUTH
        localStorage.setItem('auth', JSON.stringify(auth))
    }
    return res;
}

const handlerResOk = res => {
    if (res.ok)
        return res.json()
    throw new Error(res.status)
}

const headers = (param = {}) => {
    //headers: headers({delete: ["Content-Type"]}),
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    if (param.delete) {
        param.delete.forEach(head => {
            myHeaders.delete(head)
        });
    }
    credentials = localStorage.getItem('auth');

    if (credentials) {
        let auth = JSON.parse(credentials);
        myHeaders.append("Authorization", "Bearer " + auth.jwt);
    }
    return myHeaders;
}

const api2 = resource => {
    const url = `${Config.API.BASE + resource}`;

    return ({
        get: (id = "") =>
            fetch(`${url}${id ? `/${id}` : ''}`, {
                method: 'GET',
                redirect: 'follow',
                mode: 'cors',
                headers: headers(),
                cache: 'no-cache',
            })
                .then(res => handlerResOk(res))
                .then(res => handlerAuth(res))
                .catch(res => {

                    if (res.message == 401 || res.message == 400) {
                        localStorage.clear();
                        location.href = `/login/${b64.encode(location.pathname)}`
                    }
                }),
        patch: (id, body = {}) =>
            fetch(`${url}/${id}`, {
                method: 'PATCH',
                headers: headers(),
                redirect: 'follow',
                cache: 'no-cache',
                body: JSON.stringify(body)
            })
                .then(x => x.json()),
        put: (id, body = {}) =>
            fetch(`${url}/${id}`, {
                method: 'PUT',
                headers: headers(),
                redirect: 'follow',
                cache: 'no-cache',
                body: JSON.stringify(body)
            })
                .then(res => {
                    if (res.ok && res.headers.get("content-type").indexOf("application/json") !== -1) {
                        try {
                            return res.json()
                        } catch (err) {
                            res.text().then(content => {
                                console.error(`Api.useFormData.post(${res.url}) content:`)
                                console.error(content)
                            })
                            return { success: false }
                        }

                    } else {
                        return res.text().then(content => {
                            console.error(`Api.useFormData.post(): Headers["content-type"]:"${res.headers.get("content-type")}"`)
                            console.log(content)

                            return { success: false }
                        })

                    }
                }).catch(res => {
                    if (res[0] == '{') {
                        let err = JSON.parse(res.message)
                        if (err.status == 401) {
                            localStorage.clear();
                            location.href = '/login'
                        } else if (err.status == 200) {
                            console.error(`Api.useFormData.post(): Headers["content-type"]:"${err.contentType}"`)
                            console.log(err.content)
                        } else {
                            console.log(err.content)
                        }

                        return { success: false }
                        //TypeError
                    }
                }),
        post: (body = {}) =>
            fetch(`${url}`, {
                method: 'POST',
                headers: headers(),
                redirect: 'follow',
                cache: 'no-cache',
                body: JSON.stringify(body)
            })
                .then(x => x.json()),
        delete: (id, body = {}) =>
            fetch(`${url}/${id}`, {
                method: 'DELETE',
                headers: headers(),
                redirect: 'follow',
                cache: 'no-cache',
                body: JSON.stringify(body)
            })
                .then(x => x.json()),
        useFormData: {
            post: (body = {}, files = [], typeFiles = "images") => {
                let formdata = new FormData();
                let keys = Object.keys(body);

                for (let i = 0; i < keys.length; i++) {
                    formdata.append(keys[i], body[keys[i]]);
                }

                for (let i = 0; i < files.length; i++) {
                    formdata.append(`${typeFiles}[]`, files[i]);
                }
                return fetch(`${url}`, {
                    method: 'POST',
                    headers: headers({ delete: ["Content-Type"] }),
                    redirect: 'follow',
                    cache: 'no-cache',
                    body: formdata
                })
                    .then(res => {
                        if (res.ok && res.headers.get("content-type").indexOf("application/json") !== -1) {
                            try {
                                return res.json()
                            } catch (err) {
                                res.text().then(content => {
                                    console.error(`Api.useFormData.post(${res.url}) content:`)
                                    console.error(content)
                                })
                                return { success: false }
                            }

                        } else {
                            res.text().then(content => {
                                try {
                                    throw new Error(JSON.stringify({ status: res.status, content: content, contentType: res.headers.get("content-type") }))
                                } catch (res) {
                                    let err = JSON.parse(res.message)
                                    console.error(`Api.useFormData.post(): Headers["content-type"]:"${err.contentType}"`)
                                    console.log(err.content)
                                }
                            })
                            return { success: false }
                        }
                    }).catch(res => {
                        if (res[0] == '{') {
                            let err = JSON.parse(res.message)
                            if (err.status == 401) {
                                localStorage.clear();
                                location.href = '/login'
                            } else if (err.status == 200) {
                                console.error(`Api.useFormData.post(): Headers["content-type"]:"${err.contentType}"`)
                                console.log(err.content)
                            } else {
                                console.log(err.content)
                            }

                            return { success: false }
                            //TypeError
                        }
                    })
            },
            put: (id, body, files) => {
                let formData = new FormData();
                if (files) {
                    for (var i = 0; i < files.length; i++) {
                        formData.append("file[]", files[i]);
                    }
                }

                if (body) {
                    for (i = 0; i < Object.keys(body).length; i++) {
                        formData.append(Object.keys(body)[i], JSON.stringify(body[Object.keys(body)[i]]))
                    }
                }

                return fetch(`${url}/${id}`, {
                    method: 'PUT',
                    headers: headers({ delete: ["Content-Type"] }),
                    cache: 'no-cache',
                    body: formData
                }).then(x => x.json())
            }
        }
    })
}

export default api2;